import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Phone, MessageCircle } from 'lucide-react';

const contactMethods = [
  {
    icon: Phone,
    title: 'Téléphone',
    // PLACEHOLDER: Replace with actual phone number
    value: '+212 780 593 914',
    href: 'tel:+212780593914',
    description: 'Appelez pour prendre rendez-vous',
  },
  {
    icon: MessageCircle,
    title: 'WhatsApp',
    // PLACEHOLDER: Replace with actual WhatsApp number
    value: '+212 780 593 914',
    href: 'https://wa.me/212780593914?text=Bonjour%2C%20je%20souhaite%20prendre%20rendez-vous%20pour%20mon%20enfant.',
    description: 'Contactez-moi sur WhatsApp',
    isWhatsApp: true,
  },
];

export const Contact = () => {
  return (
    <section id="contact" className="section-padding bg-background relative">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-primary/5 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto container-padding">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <MessageCircle className="w-4 h-4" />
            <span>Contact</span>
          </div>

          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-foreground mb-6">
            Prenons{' '}
            <span className="text-gradient">contact</span>
          </h2>

          <p className="text-lg text-muted-foreground">
            N'hésitez pas à me contacter pour toute question ou pour prendre rendez-vous. Je suis là pour vous accompagner.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="max-w-2xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-6">
            {contactMethods.map((method, index) => (
              <a
                key={index}
                href={method.href}
                target={method.href.startsWith('http') ? '_blank' : undefined}
                rel={method.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="block"
              >
                <Card className={`border-0 shadow-soft hover:shadow-card transition-all duration-300 hover:-translate-y-1 h-full ${method.isWhatsApp ? 'bg-[#25D366]/5 hover:bg-[#25D366]/10' : 'bg-card'
                  }`}>
                  <CardContent className="p-6 flex flex-col items-center text-center gap-4">
                    <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${method.isWhatsApp
                      ? 'bg-[#25D366] text-white'
                      : 'bg-primary/10 text-primary'
                      }`}>
                      <method.icon className="w-8 h-8" />
                    </div>
                    <div>
                      <p className="text-sm text-muted-foreground mb-1">
                        {method.description}
                      </p>
                      <p className="font-semibold text-foreground text-lg">
                        {method.value}
                      </p>
                    </div>
                    <Button
                      variant={method.isWhatsApp ? 'whatsapp' : 'default'}
                      size="default"
                      className="mt-2"
                    >
                      {method.isWhatsApp ? 'Écrire sur WhatsApp' : 'Appeler maintenant'}
                    </Button>
                  </CardContent>
                </Card>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
